import { Component, EventEmitter, Input, NO_ERRORS_SCHEMA, OnInit, Output } from '@angular/core';
import { ServiceEventTransactionHistoryItem } from '../../../models/serviceEventTransactionHistoryItem.model';

@Component({
  selector: 'app-eventsearch-reversaltransaction',
  templateUrl: './eventsearch-reversaltransaction.component.html',
  styleUrls: ['./eventsearch-reversaltransaction.component.css'],
})
export class EventSearchReversalTransactionComponent {
  @Input() reverseTransactionModal: boolean;
  @Output() reverseTransactionModalChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() onReverseTransactionApplicationApply: boolean;
  @Input() selectedTransactionHistoryItem: ServiceEventTransactionHistoryItem;
  @Output() onModalAction: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  cancelClick() {
    this.reverseTransactionModal = false;
    this.reverseTransactionModalChange.emit(this.reverseTransactionModal);
    this.onModalAction.emit({ type: 'cancel' })
  }

  submitClick() {
    this.onModalAction.emit({ type: 'submit' })
  }
}



// WEBPACK FOOTER //
// ./src/app/components/event-search/eventsearch-reversaltransaction/eventsearch-reversaltransaction.component.ts